/**
 * PigmentProductGuard — v9
 */
(function () {
  // ─── Config: variant ID → { min, lbs } ────────────────────────
  const VARIANT_RULES = {
    // '53234352521581': { min: 50, lbs:  1 },  // Pigment 201 — 1 lb
    '53234353406317': { min: 10, lbs:  5 },  // Pigment 201 — 5 lb
    // '53234354291053': { min:  2, lbs: 25 },  // Pigment 201 — 25 lb
    // '53234352587117': { min: 50, lbs:  1 },  // Pigment 203 — 1 lb
    '53234353471853': { min: 10, lbs:  5 },  // Pigment 203 — 5 lb
    // '53234354356589': { min:  2, lbs: 25 },  // Pigment 203 — 25 lb
    '53137500537197': { min: 10, lbs:  5 },  // Shade Picker — 201-1 — 5 lb
    '53137514299757': { min:  2, lbs: 25 },  // Shade Picker — 201-1 — 25 lb
    '53137500569965': { min: 10, lbs:  5 },  // Shade Picker — 201-3 — 5 lb
    '53137514332525': { min:  2, lbs: 25 },  // Shade Picker — 201-3 — 25 lb
    '53137500602733': { min: 10, lbs:  5 },  // Shade Picker — 201-5 — 5 lb
    '53137514365293': { min:  2, lbs: 25 },  // Shade Picker — 201-5 — 25 lb
    '53137500635501': { min: 10, lbs:  5 },  // Shade Picker — 201-7 — 5 lb
    '53137514398061': { min:  2, lbs: 25 },  // Shade Picker — 201-7 — 25 lb
    '53137500799341': { min: 10, lbs:  5 },  // Shade Picker — 203-1 — 5 lb
    '53137514561901': { min:  2, lbs: 25 },  // Shade Picker — 203-1 — 25 lb
    '53137500832109': { min: 10, lbs:  5 },  // Shade Picker — 203-3 — 5 lb
    '53137514594669': { min:  2, lbs: 25 },  // Shade Picker — 203-3 — 25 lb
    '53137500864877': { min: 10, lbs:  5 },  // Shade Picker — 203-5 — 5 lb
    '53137514627437': { min:  2, lbs: 25 },  // Shade Picker — 203-5 — 25 lb
    '53137500897645': { min: 10, lbs:  5 },  // Shade Picker — 203-7 — 5 lb
    '53137514660205': { min:  2, lbs: 25 },  // Shade Picker — 203-7 — 25 lb
  };
  // ──────────────────────────────────────────────────────────────

  function getVariantId(container) {
    const node = container.querySelector('variant-selects [data-selected-variant]');
    if (!node) return null;
    try { return String(JSON.parse(node.innerHTML)?.id || ''); } catch (e) { return null; }
  }

  function getMsg(container)    { return container.querySelector('.pmg-msg'); }
  function removeMsg(container) { getMsg(container)?.remove(); }

  function enableBtn(btn)  { btn.disabled = false; }
  function disableBtn(btn) { btn.disabled = true; }

  // ── Core: evaluate one container ──────────────────────────────
  function applyGuard(container) {
    const qtyInput  = container.querySelector('input[name="quantity"]');
    const submitBtn = container.querySelector('button[name="add"]');
    if (!qtyInput || !submitBtn) return;

    removeMsg(container);

    const variantId = getVariantId(container);
    const rule      = variantId ? (VARIANT_RULES[variantId] ?? null) : null;

    if (!rule) {
      qtyInput.setAttribute('min', 1);
      qtyInput.dataset.min = 1;
      enableBtn(submitBtn);
      return;
    }

    const { min, lbs } = rule;
    qtyInput.setAttribute('min', min);
    qtyInput.dataset.min = min;

    const qty = parseInt(qtyInput.value) || 0;

    if (qty < min) {
      disableBtn(submitBtn);
      showMessage(submitBtn, container, min, lbs);
    } else {
      enableBtn(submitBtn);
    }

    // Bind qty change handler once per input element
    if (!qtyInput._pmgBound) {
      qtyInput._pmgBound = true;

      function onQtyUpdate() {
        const currentMin = parseInt(this.dataset.min || 1);
        const currentQty = parseInt(this.value) || 0;
        const c   = this.closest('product-info, quick-view-modal, .shopify-section');
        const btn = c?.querySelector('button[name="add"]') || submitBtn;

        if (currentQty < currentMin) {
          disableBtn(btn);
        } else {
          enableBtn(btn);
          //removeMsg(c || container);
        }
      }

      // Listen to BOTH events:
      // 'input'  → fires when user types manually
      // 'change' → fires when theme's +/- buttons update the value
      qtyInput.addEventListener('input',  onQtyUpdate);
      qtyInput.addEventListener('change', onQtyUpdate);
    }
  }

  // ── Evaluate all variant-selects (main page + quick view) ──────
  function evaluateAll() {
    document.querySelectorAll('variant-selects').forEach(function (vs) {
      const container = vs.closest('product-info, quick-view-modal, .shopify-section');
      if (container) applyGuard(container);
    });
  }

  // ── Message ───────────────────────────────────────────────────
  function showMessage(submitBtn, container, min, lbs) {
    if (getMsg(container)) return;

    const msg = document.createElement('div');
    msg.className = 'pmg-msg';
    msg.style.cssText = [
      'display:flex', 'align-items:center', 
      'gap:10px', 'padding:10px 12px',
      'background:#fffbd0',
      'border-radius:10px', 'font-family:inherit',
    ].join(';');

    msg.innerHTML = `
      <div style="display:flex;align-items:center;gap:8px;min-width:0">
        <span style="font-size:17px;flex-shrink:0">⚠️</span>
        <span style="font-size:15px;color:#713f12;line-height:1.4">
          Minimum order: <strong style="font-weight:600">${min} units</strong>
          <span style="color:#92400e;font-size:15px"> = ${min * lbs} lb</span>
        </span>
      </div>
`;

    // Insert BEFORE .product-form__buttons wrapper
    const formButtons = submitBtn.closest('.product-form__buttons')
      || qtyInput.closest('.product-form__buttons')
      || submitBtn.parentElement;
    formButtons.insertAdjacentElement('beforebegin', msg);
  }

  // ── Init ──────────────────────────────────────────────────────
  function init() {
    document.addEventListener('variant:changed', evaluateAll);
    evaluateAll();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();